define((require) => {
    "use strict";

    const Backbone      = require("backbone");
    const ImageTagModel = require("ui/assets/image/tags/ImageTagModel");

    const ImageTagCollection = Backbone.Collection.extend({

        model: ImageTagModel,

        /**
         * Used to maintain the collection in sorted order. Sorts by ``confidence``, ``ImageTagModel.Types.MANUAL`` and alphabetical.
         *
         * @see http://backbonejs.org/#Collection-comparator
         *
         * @param {ImageTagModel} tagA The "first" model.
         * @param {ImageTagModel} tagB The "second" model.
         * @returns {Boolean} ``false`` for the "first" model, ``true`` for the "second" model.
         */
        comparator(tagA, tagB) {
            if (tagA.get("confidence") === tagB.get("confidence")) {
                if (tagA.get("type") !== tagB.get("type")) {
                    return tagA.get("type") !== ImageTagModel.Types.MANUAL ? 1 : -1;
                }
                return tagA.get("name") > tagB.get("name") ? 1 : -1;
            }

            return tagA.get("confidence") < tagB.get("confidence") ? 1 : -1;
        },

        newCopySortedByConfidence(maxItems) {
            return new ImageTagCollection(this.first(maxItems));
        }
    });

    return ImageTagCollection;
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/image/tags/ImageTagCollection.js